import _merge from 'lodash/merge';
import { Router } from '@lightningjs/sdk';
import { t } from '../../i18n';
import { HIDE_POPUP_SIGNAL, ROUTE_BACK_SIGNAL } from '../../popupContainer/popupContainer.constants';
import { SubscriptionExpired } from '../../subscriptionExpired/subscriptionExpired.component';

export class FreemiumLockPopup extends SubscriptionExpired {
  static _template() {
    return _merge(super._template(), {
      Content: {
        ChangeButton: {
          label: t('global.close'),
        },
      },
      passSignals: {
        [HIDE_POPUP_SIGNAL]: true,
        [ROUTE_BACK_SIGNAL]: true,
      },
    });
  }

  set routeBackOnClose(value) {
    this._routeBackOnClose = value;
  }

  _handleEnter() {
    this.signal(this._getCloseActionSignal());

    return true;
  }

  _getCloseActionSignal() {
    if (this._checkHistoryAvailable()) {
      return ROUTE_BACK_SIGNAL;
    }

    return HIDE_POPUP_SIGNAL;
  }

  _checkHistoryAvailable() {
    return this._routeBackOnClose && Router.getHistory().length > 0;
  }
}
